import * as React from 'react';

import * as styles from './Week.css';

export const Week: React.FC = props => {
  const { children } = props;

  return <div className={styles['week']}>{children}</div>;
};
